import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const DeleteIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 16" },
        React.createElement("path", { d: "M12.9479 6.04736L12.0431 15.5474C12.0187 15.804 11.8032 16 11.5454 16H2.45465C2.19684 16 1.98132 15.804 1.95691 15.5474L1.05212 6.04736C1.02417 5.75384 1.255 5.5 1.54986 5.5H4.27856L6.62207 7.84344C6.83081 8.05218 7.16919 8.05218 7.37793 7.84344L9.72144 5.5H12.4501C12.745 5.5 12.9758 5.75385 12.9479 6.04736ZM13.5 2H10C9.44769 2 9 1.55225 9 1V0.5C9 0.22382 8.77612 0 8.5 0H5.5C5.22388 0 5 0.22382 5 0.5V1C5 1.55225 4.55231 2 4 2H0.5C0.22388 2 0 2.22382 0 2.5V3.5C0 3.77612 0.22388 4 0.5 4H13.5C13.7761 4 14 3.77612 14 3.5V2.5C14 2.22382 13.7761 2 13.5 2Z" })));
};

export { DeleteIcon };
//# sourceMappingURL=DeleteIcon.esm.js.map
